import React, {  useState } from "react";
import { useDispatch } from "react-redux";
import { Link} from "react-router-dom";
import { toast } from "react-toastify";
import InputField from "../../components/InputField/InputField";
import Config from "../../Config";
import {  SIGNUP_FAIL, SIGNUP_REQUEST, SIGNUP_SUCCESS } from "../../store/actions";
import useQuery from "../../hooks/useQuery";
import {REGIONS} from "../../utils/constants";

const SignupForm = ({ t }) => {
    const dispatch = useDispatch()
    const query = useQuery()

    const [signupData, setSignupData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        confirmpassword: "",
        region: query.get("region")?.toLowerCase() || "us"
    })

    const [isLoading, setIsLoading] = useState(false)

    const handleSubmit = () => {
        const { firstName, lastName, email, password, confirmpassword, region } = signupData
        if (!firstName || !lastName || !email || !password || !confirmpassword) {
            toast.error(t("form_fields_are_required"));
            return false;
        }

        if (password.trim() !== confirmpassword.trim()) {
            toast.error(t("new_password_and_confirm_password_do_not_match"));
            return false;
        }
        setIsLoading(true);
        debugger;
        fetch(`${Config.env().API_URL}/sso-register`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ email, password, firstName, lastName, region })
        })
            .then((response) => response.json())
            .then(async (response) => {
                if (response.error) {
                    toast.error(response.error.message)
                    return;
                }
                dispatch({ type: SIGNUP_REQUEST });
                dispatch({ type: SIGNUP_SUCCESS, payload: response });
                toast.success("Your account was created successfully!")
                setSignupData({
                    email: "",
                    password: "",
                    confirmpassword: "",
                    firstName: "",
                    lastName: "",
                    region: ""
                })
                return Promise.resolve(response);
            })
            .catch((error) => {
                dispatch({
                    type: SIGNUP_FAIL,
                    payload: error,
                });
                return Promise.reject(error?.message || "signup failed");
            })
            .finally(async () => {
                setIsLoading(false)
            })
    }

    const handleChange = (evt) => {
        setSignupData({ ...signupData, [evt.target.name]: evt.target.value });
    };
    return (
        <div className="signup__field pt-5">
            <p>{t("create_Account")}</p>
            <InputField
                type="text"
                placeholder={"first_name"}
                name="firstName"
                secure={false}
                onChange={handleChange}
                value={signupData?.firstName}
            />
            <InputField
                type="text"
                placeholder={"last_name"}
                name="lastName"
                secure={false}
                value={signupData?.lastName}
                onChange={handleChange}
            />
            <InputField
                type="email"
                placeholder={"email"}
                name="email"
                secure={false}
                onChange={handleChange}
                value={signupData?.email}
            />
            <InputField
                type="password"
                placeholder={"password"}
                name="password"
                secure={true}
                value={signupData?.password}
                onChange={handleChange}
            />
            <InputField
                type="password"
                placeholder={"confirm_password"}
                name="confirmpassword"
                secure={true}
                value={signupData?.confirmpassword}
                onChange={handleChange}
            />

            <div className="region-select">
                <select
                    id={"region"}
                    name="region"
                    className="bg-transparent input-feild"
                    style={{
                        width: "100%",
                        height: 50,
                        margin: 0,
                        padding: "0px 10px",
                        color: "rgb(255, 255, 255)",
                        border: "1px solid rgb(255, 255, 255)",
                    }}
                    onChange={handleChange}
                    value={signupData?.region}
                >
                    <option style={{background: "#332d3b"}} value="">{t("region")}</option>
                    {REGIONS.map((region, index) => {
                        return (
                            <option style={{background: "#332d3b"}} value={region.value} key={index}>
                                {region.label}
                            </option>
                        );
                    })}
                </select>
            </div>

            <button
                onClick={handleSubmit}
                className="btn btn-primary mt-4"
            >
                {isLoading ? (
                    <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                    ></span>
                ) : (
                    t("register")
                )}
            </button>
            <Link to={`/login?region=${signupData?.region}`} className="d-block text-center pt-3 btn-link">
                {t("back_to_Login")}
            </Link>
        </div>
    )
}

export default SignupForm